export function hasInvalidFileSize(fileList: File[]): boolean {
    const hasInvalidFile = fileList.filter(file => {
        return file.size > 52428800;
    });

    return hasInvalidFile.length > 0;
}

export function hasInvalidFileExtension(fileList: File[], acceptedExtensions: string): boolean {
    const extensions = acceptedExtensions.toLowerCase().replace(/[ \.]+/g, '').split(',');
    const hasInvalidFile = fileList.filter(file => {
        const fileExtension =  file.name.toLowerCase().split('.').pop();
        return !fileExtension || !extensions.includes(fileExtension);
    });

    return hasInvalidFile.length > 0;
}
